<div class="tab-content">

    <div class="hero-text" style="margin-left: 10px;">
        <h1 style="font-weight: 800;">{{"DEVICE_UPDATE_CONFIRMATION" | translate}}</h1>
    </div>


    <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
        <mat-label>{{"PASSWORD" | translate}}</mat-label>
        <input matInput  [(ngModel)]="password" required>
    </mat-form-field>

    <button mat-raised-button (click)="confirm()">
        <span>{{"APPROVE" | translate}}</span>
    </button>

</div>